// components/widgets/primitives/meta-field.js
// ═══════════════════════════════════════════════════════════
// META FIELD — small uppercase mono label + value pair.
// e.g. "ASSUMES  things you already trade by"
//      "SOURCE   0 sessions logged"
// Used inside chips, misdirections, possibilities, etc.
// ═══════════════════════════════════════════════════════════

export default function MetaField({ label, children, className = '' }) {
  if (children == null || children === '') return null;
  return (
    <div className={`ws-prim-meta-row ${className}`}>
      <span className="ws-prim-meta-label">{label}</span>
      <span className="ws-prim-meta-text">{children}</span>
    </div>
  );
}
